import { render, staticRenderFns } from "./PaymentRejected.vue?vue&type=template&id=3e83bcab&scoped=true"
var script = {}
import style0 from "./PaymentRejected.vue?vue&type=style&index=0&id=3e83bcab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83bcab",
  null
  
)

export default component.exports